import React, { useCallback } from 'react';
import { headerCss } from '../common/Css';
import { Disclosure } from '@headlessui/react';
import { useSelector, useDispatch } from 'react-redux';
import { Skeleton } from '@mui/material';
import { Outlet, useLocation, useNavigate, useSearchParams, } from 'react-router-dom';
import { HeaderLogo, profileComponent } from '../layout/header/Header';
import { closeModalAction, openCustomModal, openTextModalAction } from '../actions/modal';
import { signOutUserAction } from '../actions/auth';
import IconToolTip from '../common/IconToolTip';
import DropdownMenu from '../common/MenuDropdown';
import TextModal from '../common/Modals/TextModal';
import CustomModal from '../common/Modals/CustomModal';
import MediaView from '../common/MediaView';
import { isMobileView } from '../utils/utils';
import { GetQueryParam } from '../utils/common';

const SupportTrackLayout = () => {
    const { isUIConfigLoading } = useSelector(state => state.loading);
    const { isTextModalOpen, isCustomModalOpen, isMediaViewModalOpen } = useSelector((state) => state.modal);
    const [searchParams, setSearchParams] = useSearchParams();
    const redirectTo = GetQueryParam('redirectTo');

    return (
        <div className='h-screen bg-scogolightblue'>
            <Disclosure as='div' className='header fixed w-full z-50 flex items-center justify-between'>
                {({ open }) => (
                    <>
                        <div className={`${headerCss?.mainDiv} w-full flex items-center justify-between `}>
                            {isUIConfigLoading ?
                                <Skeleton variant='rectangular' animation='wave' height='3rem' width='5rem' />
                                :
                                <div className='flex w-full justify-between items-center' style={{
                                    flexFlow: 'row',
                                }}>
                                    <div className='flex flex-initial'><HeaderLogo /></div>
                                    {isMobileView ? <div className='flex flex-initial gap-0 md:gap-2 items-center justify-center'>
                                        <RenderDetailsIcon label={`${redirectTo === 'chat' ? 'Detail' : 'Chat'}`} extraClass='' onClick={() => {
                                            const currentParams = {};
                                            for (const [key, value] of searchParams.entries()) {
                                                currentParams[key] = value;
                                            }
                                            let newParams = {
                                                ...currentParams,
                                            };
                                            if (redirectTo === 'chat') newParams.redirectTo = 'detail';
                                            else newParams.redirectTo = 'chat';
                                            setSearchParams(newParams);
                                        }} />
                                        <HeaderActions />
                                    </div> : null
                                    }
                                </div>
                            }
                        </div>
                    </>
                )}
            </Disclosure>
            <div className='flex bg-scogof8 md:overflow-auto lg:overflow-hidden'>
                <div className='mainContainerForUnauthorisedUser'>
                    <Outlet />
                </div>
            </div>
            {isTextModalOpen && <TextModal />}
            {isCustomModalOpen && <CustomModal />}
            {isMediaViewModalOpen && <MediaView />}
        </div>
    );
};

export default SupportTrackLayout;


const RenderDetailsIcon = ({ onClick, extraClass = '', label = 'Details' }) => {
    return (
        <button
            onClick={onClick}
            className={`ml-auto flex flex-col items-center justify-center px-5 py-2 text-white bg-gradient-to-r from-blue-500 via-indigo-600 to-purple-700 rounded-3xl shadow-lg hover:from-purple-700 hover:via-indigo-800 hover:to-blue-800 transition-colors duration-300 focus:outline-none focus:ring-4 focus:ring-purple-300 ${extraClass}`}
            aria-label="Show details"
        >
            {label}
        </button>
    );
};


const HeaderActions = () => {
    const navigate = useNavigate();
    const newLoggedUserData = useSelector((state) => state.auth.newLoggedUserData);
    if (!newLoggedUserData) return <></>;

    let logoutAction = {
        menuName: 'Sign out',
        menuIcon: 'logout',
        onClick: (item, dispatch) => {

            return dispatch(
                openTextModalAction({
                    heading: 'Sign Out',
                    text: 'Are you sure you want to sign out?',
                    formName: 'signOutUser',
                    buttons: [
                        {
                            showLoading: true,
                            textOrComponent: 'Yes',
                            type: 'red',
                            buttonClass: 'hover:bg-scogoLightFillRed',
                            onClick: () => {
                                dispatch(signOutUserAction(navigate));
                            },
                        },
                        {
                            textOrComponent: 'No',
                            type: 'blue',
                            onClick: () => dispatch(closeModalAction()),
                        },
                    ],
                    closeOnBackdropClick: false,
                })
            );
        },
    };

    return <div className='w-[3.2rem] ml-2'>
        <IconToolTip title={newLoggedUserData ? `${newLoggedUserData.user.full_name}` : ''}>
            <DropdownMenu
                menuData={[logoutAction]}
                componentOrIcon={() => profileComponent(newLoggedUserData.user.avatar_link)}
                iconColor={'text-scogoprimary'}
            />
        </IconToolTip>
    </div>
};